import { FormGroup, Label, Input } from 'reactstrap';
import { ConfirmStringDialog } from '../../components/ConfirmStringDialog';
import { useAnonymizeUser } from './userMutations';
import { isApiError } from '../../api/errors';
import { toast } from 'react-toastify';

const REQUIRED = 'I_UNDERSTAND_THIS_IS_IRREVERSIBLE';

/**
 * DSGVO Art. 17 Anonymisierung. Pflicht-String-Bestätigung + Reason.
 * Spec: orbit-specs/done/user-crud-admin.md → "Anonymize-Modal"
 */
export function AnonymizeUserDialog({ isOpen, user, onClose }) {
  const anonymize = useAnonymizeUser();
  if (!user) return null;

  const onConfirm = async (payload) => {
    if (!payload.reason?.trim()) {
      toast.error('Reason ist erforderlich.');
      return;
    }
    try {
      await anonymize.mutateAsync({
        id: user.id,
        reason: payload.reason.trim(),
        confirmation: payload.confirmation,
      });
      onClose();
    } catch (err) {
      // useApiMutation zeigt schon den Error-Toast — hier nur Modal-Recovery
      if (!isApiError(err)) {
        toast.error('Unerwarteter Fehler — siehe Console.');
      }
    }
  };

  return (
    <ConfirmStringDialog
      isOpen={isOpen}
      title={`DSGVO-Anonymisierung · #${user.id}`}
      body={
        <>
          <p className="mb-2">
            <strong>Nicht reversibel.</strong> Der Account wird auf <code>status=deleted</code>{' '}
            gesetzt, PII-Felder gelöscht. Rechnungen + Audit-Log bleiben erhalten gemäß
            § 147 AO.
          </p>
          <p className="mb-0 small">
            Job läuft asynchron im Worker. Status-Refresh über die Liste sichtbar.
          </p>
        </>
      }
      requiredString={REQUIRED}
      busy={anonymize.isPending}
      onConfirm={onConfirm}
      onCancel={onClose}
      initialExtras={{ reason: '' }}
      renderExtraFields={(extras, setExtras) => (
        <FormGroup>
          <Label className="small fw-semibold">Grund (für Audit-Log) *</Label>
          <Input
            type="textarea"
            rows={2}
            value={extras.reason ?? ''}
            onChange={(e) => setExtras((p) => ({ ...p, reason: e.target.value }))}
            placeholder="z. B. DSGVO Art. 17 Request via Mail #4711"
            maxLength={500}
          />
        </FormGroup>
      )}
    />
  );
}
